/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createCsc } from '../../factoriesAny.js';
export var cscDependencies = {
  BigNumberDependencies: BigNumberDependencies,
  typedDependencies: typedDependencies,
  createCsc: createCsc
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesCsc.generated.js
// module id = 1380
// module chunks = 0